import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Certifications from "@/pages/Certifications";

export const Route = createFileRoute("/zh-cn/certifications")({
  head: () => buildRouteHead("/zh-cn/certifications"),
  component: Certifications,
});

